import {useEffect, useState} from 'react'
import {useFetchOneEntry} from '../../hooks/useFetchOneEntry'
import modelMap from 'hec/builder/model-map'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useFetchBuilderReference} from './useFetchBuilderReference'
import {useCookieTracker} from '~/app/utils/cookieTracking/CookieTrackerProvider'

export const useGetTpaBanner = ({isEdit, displayTpaBannerInEditor, tpaBannerToDisplayInEditor}) => {
    const config = getConfig()
    const {cookieValues} = useCookieTracker()
    const [tpaId, setTpaId] = useState('')

    const shouldQueryTpaBannerInEditor =
        !tpaBannerToDisplayInEditor?.value && isEdit && displayTpaBannerInEditor

    const {data: tpaBannerSymbolInEditorData, isLoading: tpaBannerSymbolInEditorLoading} =
        useFetchBuilderReference({
            model: modelMap.tpaWelcomeBanner,
            shouldQuery: shouldQueryTpaBannerInEditor,
            referenceId: tpaBannerToDisplayInEditor?.id
        })

    useEffect(() => {
        if (
            isEdit &&
            displayTpaBannerInEditor &&
            tpaBannerToDisplayInEditor &&
            tpaBannerSymbolInEditorData?.data?.tpaId
        ) {
            setTpaId(tpaBannerSymbolInEditorData.data.tpaId)
        } else if (!isEdit && cookieValues?.tpaBranding?.afid) {
            setTpaId(cookieValues.tpaBranding.afid)
        }
    }, [
        cookieValues?.tpaBranding?.afid,
        isEdit,
        tpaBannerSymbolInEditorData,
        tpaBannerSymbolInEditorData?.data?.tpaId,
        tpaBannerToDisplayInEditor,
        displayTpaBannerInEditor
    ])

    const {data, isLoading} = useFetchOneEntry({
        queryKey: [modelMap.tpaWelcomeBanner, tpaId],
        options: {
            model: modelMap.tpaWelcomeBanner,
            apiKey: config.app.builder.api,
            query: {data: {tpaId}}
        },
        enabled: !!tpaId
    })

    return {
        data,
        isLoading:
            (isLoading && !!tpaId) ||
            (tpaBannerSymbolInEditorLoading && shouldQueryTpaBannerInEditor)
    }
}
